<template>
<div class='image-uploader-wrapper'>
  <div class='img' :style="{ backgroundImage: 'url(' + image + ')' }" v-if='image' />
  <div class='img default' v-else />
  <el-button class='media-btn' @click='openMediaImageDialog'></el-button>
  <p class='hint'>{{title || $t('actions.imageUploader.defaultCoverHint')}}</p>
</div>
</template>

<script>
export default {
  data() {
    return {
      image: null
    }
  },
  props: {
    value: [String, Number, Object],
    title: String,
    tag: {
      type: String,
      default: 'thumbnail'
    }
  },
  watch: {
    value: function(newValue) {
      this.setImage(newValue)
    }
  },
  methods: {
    setImage(value) {
      let vm = this
      if (typeof value === 'string') {
        vm.image = value
      } else if (!value) {
        vm.image = null
      } else {
        if (value.file_url) {
          vm.image = value.file_url
        }

        if (value.id) {
          vm.$emit('input', value.id)
        }
      }
    },
    openMediaImageDialog() {
      let vm = this

      vm.$mediaImage({
        initTag: vm.tag,
        success: vm.setImage
      })
    }
  },
  mounted: function() {
    let vm = this
    vm.$nextTick(function() {
      // init value
      if (vm.value) {
        vm.setImage(vm.value)
      }
    })
  }
}
</script>

<style lang='scss'>
.image-uploader-wrapper {
    width: 100%;
    height: 100%;
    border: $border-base;
    position: relative;

    > .hint {
        color: white;
        z-index: 10;
        position: absolute;
        text-align: center;
        width: 100%;
        margin: 0;
        line-height: 1;
        padding: 0.2em 0;
        background-color: $color-black-base;
        bottom: 0;
    }

    > .img {
        position: absolute;
        background-color: $color-white-base;
        &:first-of-type {
            z-index: 1;
        }

        &.default {
            background-image: url('~@/assets/images/project-wechat-cover-default.jpg');
        }
    }

    .media-btn {
        padding: 0;
        margin: 0;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
}
</style>



// WEBPACK FOOTER //
// image_uploader.vue?30cc5d22